const styles = {
  alert: {
    boxSizing: 'border-box',
    display: 'flex',
    alignItems: 'flex-start',
    '& .MuiAlert-message': {
      width: '100%',
      flex: 1,
    },
  },
  message: {
    textAlign: 'left',
  },
  details: {},
  detailsExpanded: {
    maxHeight: 150,
    overflowY: 'auto',
    paddingRight: 1,
  },
  toggleButton: {
    marginTop: 1,
    alignSelf: 'flex-start',
    padding: 0,
    minWidth: 'auto',
  },
}

export default styles
